const ActionMessage = ({ actionMsg }) => {
  return (
    <div
      style={{
        background: '#f0fdf4',
        border: '1px solid #86efac',
        borderRadius: 10,
        padding: '10px 16px',
        marginBottom: 20,
        fontSize: 13,
        color: '#15803d',
        fontWeight: 500,
      }}
    >
      {actionMsg}
    </div>
  );
};

export default ActionMessage;
